import { render, staticRenderFns } from "./OrderListHuo.vue?vue&type=template&id=1fe94d60&scoped=true&"
import script from "./OrderListHuo.vue?vue&type=script&lang=js&"
export * from "./OrderListHuo.vue?vue&type=script&lang=js&"
import style0 from "./OrderListHuo.vue?vue&type=style&index=0&id=1fe94d60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe94d60",
  null
  
)

export default component.exports